<template lang="pug">
  component(
    v-if='component && genre'
    :is='component'
    :genre='genre'
  )
</template>

<script>
import dinamicComponentMixin from "@/mixins/shared/dinamicComponent.mixin";

import cardTemplate from "./templates/card";
import fullTemplate from "./templates/full";

export default {
  props: ["genre"],
  data() {
    return {
      templates: {
        card: cardTemplate,
        full: fullTemplate
      }
    };
  },
  mixins: [dinamicComponentMixin]
};
</script>
